import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { MoreErrorsComponent } from './more-errors.component';

import { MatButton } from '@angular/material/button';

interface ErrorSnackBarData {
  message: string;
  numberOfOtherErrors?: number;
  otherErrors?: string;
}

@Component({
    selector: 'app-error-snack-bar',
    template: `
    <div>
      {{ data.message }}
      <button type="button" mat-button (click)="closeSnackbar()" style="float: right" color="accent">
        Close
      </button>
      @if (data.numberOfOtherErrors && data.numberOfOtherErrors > 0) {
        <button type="button" mat-button (click)="showMore()" style="float: right">
          Show {{ data.numberOfOtherErrors }} Others
        </button>
      }
    </div>
    `,
    styleUrls: ['error-snack-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButton]
})
export class ErrorSnackbarComponent {
  snackbar = inject(MatSnackBar);
  dialog = inject(MatDialog);
  data = inject<ErrorSnackBarData>(MAT_SNACK_BAR_DATA);


  showMore() {
    this.dialog.open(MoreErrorsComponent, {
      data: JSON.parse(this.data.otherErrors),
    });
  }

  closeSnackbar() {
    this.snackbar.dismiss();
  }
}
